import { ButtonGroup } from "@xola/ui-kit";
import clsx from "clsx";
import { FormField } from "common";
import dayjs from "dayjs";
import { useFormikContext } from "formik";
import { capitalize } from "lodash";
import React from "react";
import { BaseScheduleType, CheckInValidation } from "types";
import { BaseScheduleFilterType } from "@/components/BaseSchedule/BaseScheduleInput";
import { TimePickerPopover } from "@/components/Common/TimePickerPopover";
import { filterCheckInWindowValidations } from "@/components/Product/ExperienceCheckIn/CheckInWindow/PurchaseCutoffScheduleInput";
import { CutoffScheduleFormValues } from "@/components/Product/ExperienceCheckIn/ExperienceCheckIn.types";
import { getDuration } from "@/helpers/durationHelper";

interface FilterButtonGroupProps {
    validations: CheckInValidation[];
    type: BaseScheduleFilterType;
    onChange: (type: BaseScheduleFilterType) => void;
}

export const FilterButtonGroup = ({ validations, type, onChange }: FilterButtonGroupProps) => {
    const getCount = (filter: BaseScheduleFilterType) => filterCheckInWindowValidations(validations, filter).length;
    const filters = [BaseScheduleFilterType.ACTIVE, BaseScheduleFilterType.EXPIRED, BaseScheduleFilterType.ALL];

    const handleChange = (value: number) => {
        onChange(filters[value]);
    };

    return (
        <ButtonGroup className="mr-2 align-top" value={filters.indexOf(type)} onChange={handleChange}>
            {filters.map((filter) => (
                <ButtonGroup.Button key={filter}>
                    {capitalize(filter)} ({getCount(filter)})
                </ButtonGroup.Button>
            ))}
        </ButtonGroup>
    );
};

export const PurchaseCutoffContent = () => {
    const { values, errors, setFieldValue } = useFormikContext<CutoffScheduleFormValues>();
    const duration = dayjs.duration(values.duration ?? "").asMinutes();

    const handleCutoffChange = (value: number) => {
        setFieldValue("duration", getDuration(value).toISOString());
    };

    return (
        <FormField name="terms" label="Terms">
            <span className="flex flex-wrap gap-x-1" onClick={(e) => e.stopPropagation()}>
                {values.type === BaseScheduleType.AVAILABLE
                    ? "All guests must check-in within"
                    : "Guests cannot check-in within"}
                <TimePickerPopover
                    showArrow
                    classNames={{
                        text: clsx(
                            "px-0.5 pb-0.5 mx-1",
                            errors.duration ? "!text-danger !border-danger" : "!text-black !border-black",
                        ),
                    }}
                    value={duration}
                    onApply={handleCutoffChange}
                />
                of purchase date
            </span>
        </FormField>
    );
};
